import React from 'react'
import s from './TcRedirectionRoute.less'
import { useSelector } from 'react-redux'
import { selectCurrentMode, selectTcAvailabilityInfo } from '../../../store/itinerary/itinerary.selectors'
import { MULTIPATH_MODE_TC } from '../../../store/itinerary/itinerary.constants'
import { selectSeoArrival, selectSeoDeparture, selectStepsCoordinates } from '../steps/steps.selectors'
import TagActionLink from '../../genericComponents/TagActionLink'
import { PUB_TAG } from '../../analytics/PublisherTagsService'
import { TAG_MULTIPATH_CTA } from '../../analytics/analytics.tagids.constants'

const TcRedirectionRoute = () => {
  const currentMode = useSelector(selectCurrentMode)

  const departureLabel = useSelector(selectSeoDeparture)?.label
  const arrivalLabel = useSelector(selectSeoArrival)?.label
  const coordinates = useSelector(selectStepsCoordinates)

  const availabilityInfo = useSelector(selectTcAvailabilityInfo)

  if (currentMode !== MULTIPATH_MODE_TC || !availabilityInfo) return <></>

  const { message, img, link } = availabilityInfo

  const buildRedirectLink = `${link?.href}#${departureLabel}|${coordinates?.departure.lng},${coordinates?.departure.lat}/${arrivalLabel}|${coordinates?.arrival.lng},${coordinates?.arrival.lat}`

  return (
    <TagActionLink
      tagInfo={{ tag: PUB_TAG.PUB_MULTIPATH_TC_NO_RESULT }}
      type={TAG_MULTIPATH_CTA}
      shouldTagImpression={true}
      href={buildRedirectLink}
      className={s.container}
      target="_blank"
      rel="noreferrer"
    >
      <img className={s.img} src={img.svg} alt={''} />
      <div>
        <span>{message}&nbsp;</span>
        <span className={s.link}>{link.label}</span>
      </div>
    </TagActionLink>
  )
}

export default TcRedirectionRoute
